import type BookingMeetingType from 'owa-service/lib/contract/BookingService';
import type ServicesRequestStatus from './ServicesRequestStatus';
import type BookingDashboard from './BookingDashboard';
import type PersonalBookingPageShownView from './PersonalBookingPageShownView';
import type { MeetingTypeEditOptionState } from './MeetingTypeEditOptionState';
import type PersonalBookingPagePublishingSettings from './PersonalBookingPagePublishingSettings';
import type MeetingTypeExtensionResponse from '../../services/schema/MeetingTypeExtensionResponse';
import type SharedViewState from './SharedViewState';
import type { FREState } from './FREState';
import type InboxReminderType from 'owa-service/lib/contract/InboxReminderType';

export enum PublishStatus {
    Pending,
    Publishing,
    Incomplete,
    Complete,
    Published,
}

export type ReadPivot = 'Dashboard' | 'Analytics' | 'Bookings';

export enum AutoPublishState {
    Pending,
    Complete,
}

export enum UserOnboardingState {
    UserFirstVisitPreFRE,
    UserFirstSesionPostFRE,
    UserFirstSessionDefaulServiceCreated,
    UserDefaultServiceOnboarded,
    UserPreviousFlowOnboarded,
}

interface BookWithMeOrganizerStore {
    selectedReadPivot: ReadPivot | null;
    bookingDashboard: BookingDashboard;
    meetingTypes: Map<string, BookingMeetingType> | null;
    inboxReminders: InboxReminderType[];
    currentMeetingTypeId: string | null;
    sharedViewState: SharedViewState;
    organizerProfilePicture: string | undefined;
    /**
     * Holds the current saving status of the PBP settings.
     */
    isSaving: boolean;
    isTurningOnBookingPage: boolean;
    /**
     * Holds the current service action state.
     */
    isPerformingServiceUpdate: boolean;

    /**
     * Status of the get meetingTypes request.
     */
    getServicesRequestStatus: ServicesRequestStatus;

    /*
     * Holds the view we are currently showing.
     */
    shownView: PersonalBookingPageShownView;

    /*
     * Holds the state of the Service that is being edited.
     * (i.e) Service id, name, duration, location etc.
     */
    meetingTypeEditState: MeetingTypeEditOptionState;

    pbpPublishingSetting: PersonalBookingPagePublishingSettings;
    meetingTypeExtensions: Map<string, MeetingTypeExtensionResponse> | null;
    meetingTypeExtension: MeetingTypeExtensionResponse | null;
    firstTimeUser: boolean;
    firstRunState: FREState;
    mailboxHash: string;
    entryPoint: string;
    BookingPagePublishedStatus: PublishStatus;
    /*
     * Holds the status of the first call of getBookingSessionData
     */
    isGettingBookingSessionData: boolean;

    // TODO: This logic for this should be simplified and unified across everything.
    // Overall status of Pbp access.
    pbEnabledStatus: ServicesRequestStatus;

    // Validation to see if the user has teams enabled
    isTeamsMeetingEnabled: boolean;

    // status of the autopublish for new users
    // Intialized to "Pending", this state only is relevant for new users scenarios
    // TODO: this will moved once new Publishing architecture is done
    newUserAutoPublishState: AutoPublishState;
    userOnboardingState: UserOnboardingState;
    // Before we begin reading the publishing settings of a new user, we should do a
    // master check to see if the page is published on the organizer and attendee side
    // we will know this with a simple call to getBookingSessionData
    // IF the api returns a good response, then we know both publishing scenarios are complete
    // Doing the master call should help us avoid putting the user in a bad state
    // TODO: this will moved once new Publishing architecture is done
    masterPublished: boolean;
    // For new users we should track to see if a CheckBookingPagePublished is in progress
    // This will help us reduce calls to GMTE and GetBookingSessionData
    // default to false
    checkBookingPagePublishedIsCalled: boolean;
    bookingMailboxPuid: string;
    showServiceOutageBanner: boolean;
    isCreate: boolean;
    isPageSharedOrEmailSignatureAdded?: boolean;
    isUpdateUserConfigInitiated?: boolean;
    linkGeneratedServiceIds: string[];
}

export default BookWithMeOrganizerStore;
